import axios from 'axios'

export default class WildfireResendVerification {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...WildfireResendVerification.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.resendVerificationUrl = this.DOM.$el.dataset[this.options.attrResendVerificationUrl];
        this.resendButton = this.DOM.$el.querySelector(this.options.selectorResendButton);
        this.resendMessage = this.DOM.$el.querySelector(this.options.selectorResendMessage);
        this.sentMessage = this.DOM.$el.querySelector(this.options.selectorSentMessage);
        this.spinner = '<img id="spinner" style="display: inline; animation: spinner 1s linear both infinite;" src="/assets/2.0/img/spinner-color-small.png";" />';
        this.resendButton.addEventListener('click', (e) => {
            e.preventDefault()
            this.resend(this.resendVerificationUrl);
            this.resendButton.classList.add('u-hide');
            this.resendMessage.insertAdjacentHTML('beforeend', this.spinner);
        })
    }

    resend(url) {
        axios.post(url)
            .then((data) => {
                if (data.data.hasOwnProperty('reload')) {
                    location.reload();
                    return;
                }

                if (data.data.hasOwnProperty('message')) {
                    this.sentMessage.innerHTML = data.data.message;
                }

                this.resendMessage.classList.add('u-hide');
                this.sentMessage.classList.remove('u-hide');
            })
            .catch(function (error) {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    if (error.response.headers.hasOwnProperty('location')) {
                        window.location = error.response.headers.location
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                } else {
                    // Something happened in setting up the request that triggered an Error
                    // console.log('Error', error.message);
                }
            })
    }
}

    WildfireResendVerification.prototype.defaults = {
    attrResendVerificationUrl: 'wildfireResendVerificationUrl',
    selectorResendMessage: '.resend-message',
    selectorSentMessage: '.sent-message',
    selectorResendButton: '.resend-button',
}